import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ViewNavBar from "./ViewNavBar";
import Footer from "./Footer";
import ProductsSection from "./ProductsSection";

const Products = () => {
  const location = useLocation();

  useEffect(() => {
    const targetId = location.state?.scrollTo;
    if (!targetId) return;

    let attempts = 0;
    const maxAttempts = 50; 

    const tryScroll = () => {
      const el = document.getElementById(targetId);

      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }
      return false;
    };

    if (tryScroll()) return;

    const interval = setInterval(() => {
      attempts += 1;
      if (tryScroll() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [location]);

  return (
    <>
      <ViewNavBar atPage={"products"} />
      <main id="main-content">
        <ProductsSection />
      </main>
      <Footer />
    </>
  );
};

export default Products;